import { requestPermission } from "../service/RequestPermission";

const PermissionConfig = () => {
  requestPermission({ type: "PermissionConfig" });
};

export default PermissionConfig;
